

































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import EditorTest from '../../components/UI/EditorTest.vue';
import { IMilestone } from '../../models';
import { BaseDetail } from '../Base/BaseDetail';

const namespace = 'milestone';
const ns = { namespace };

@Component({
  components: {
    EditorTest,
  },
})
export default class MilestoneDetail extends BaseDetail<IMilestone> {
  namespace = namespace;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  mounted() {
    this.loadEntity();
  }
}
